import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { StyledLayout } from './styled';
import useScrollState from '../../../hooks/useScrollState';

const MainLayout = ({ language, isWebView, children }) => {
  const { isScroll } = useScrollState();
  const isWebViewScroll = Boolean(isWebView && isScroll);

  return (
    <StyledLayout
      className={cn(`locale-${language}`, {
        scrolling: isWebViewScroll
      })}
      $isWebViewScroll={isWebViewScroll}
    >
      {children}
    </StyledLayout>
  );
};

export default MainLayout;

MainLayout.propTypes = {
  language: PropTypes.string,
  isWebView: PropTypes.bool,
  children: PropTypes.node
};
